<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>{{ org?.name }}: Calendar</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/organisations']">Organisations</a>
          </li>
          <li class="breadcrumb-item active">Connectors</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">
      <app-calendar-form [org]="org"></app-calendar-form>
    </div>
  </div>
</section>
